import React, { memo, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import TextField from "@material-ui/core/TextField";
import { useRecoilState } from 'recoil';

import { useSpinner } from '../../../../../core/contexts/SpinnerContext';
import { useNotification } from "../../../../../core/contexts/NotificationContext";
import { addVehicle, updateVehicle } from "../../../../Common/Apis/VehicleApi";
import { IAsset, assetTabIndexState, assetTabListState, assetListRefreshState } from '../store/AssetsStore';

interface IProps {
  item?: IAsset;
}

type FormData = {
  vehiclePlate: string;
  vehicleCode: string;
  fleetName: string;
  SensorSerialNumber: string;
};

const AssetDetail = ({ item }: IProps) => {

  const { showSuccess } = useNotification();
  const { setSpinner } = useSpinner();

  const [, setTabIndex] = useRecoilState(assetTabIndexState);
  const [tabList,] = useRecoilState(assetTabListState);
  const [refreshStatus, setRefreshStatus] = useRecoilState(assetListRefreshState);

  const { control, handleSubmit, reset, formState: { errors } } = useForm<FormData>({
    defaultValues: {
      vehiclePlate: item?.VehiclePlate ?? '',
      vehicleCode: item?.VehicleCode ?? '',
      fleetName: item?.FleetName ?? '',
      SensorSerialNumber: item?.SensorSerialNumber ?? '',
    }
  });

  useEffect(() => {
    //activate this tab
    const thisIndex = tabList.findIndex((i) => i.VehicleId === item?.VehicleId);
    setTabIndex(thisIndex + 2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit: SubmitHandler<FormData> = async data => {

    try {

      setSpinner(true);

      if (item) {
        //update vehicle]

        await updateVehicle(item.VehicleId, data.vehiclePlate, data.vehicleCode, data.fleetName);
      }
      else {
        //create vehicle
        await addVehicle(data.vehiclePlate, data.vehicleCode, data.fleetName, data.SensorSerialNumber);
        reset();
        setTabIndex(0);
      }

      showSuccess("success", "sucessfully saved", "", 3000, null);
    }
    catch (err) {
      console.log('err', err);
    }

    setRefreshStatus(!refreshStatus);
    setSpinner(false);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="col-lg-7  mt-3">
          <div className="tab-content" id="myTabContent">
            <div className="card">

              <div className="card-body">
                <div className="row  mt-3">
                  <div className="col-6 ">
                    <Button
                      type="submit"
                      className="mb-3 ml-3"
                      style={{ fontWeight: "600" }}
                      variant="contained"
                      color="primary"
                    >
                      Save
                    </Button>
                  </div>
                  <div className="col-6 text-right ">
                    {!item &&
                      <Button
                        type="button"
                        className="mb-3 ml-3"
                        style={{ fontWeight: "600" }}
                        variant="contained"
                        color="default"
                        onClick={() => reset()}
                      >
                        Reset
                      </Button>
                    }
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-sm-6">
                    <div className="p-number">
                      <Controller
                        name="vehiclePlate"
                        rules={{ required: true }}
                        control={control}
                        render={({ field }) =>
                          <TextField
                            {...field}
                            style={{ width: "100%" }}
                            label=""
                            variant="outlined"
                            size="small"
                            error={errors.vehiclePlate ? true : false}
                            helperText={""}
                          />}
                      />


                    </div>
                    <span className="p-num-span mr-2">
                      vehicle Plate
                    </span>
                    {errors.vehiclePlate && <p className="text-danger2">should not be blank</p>}

                  </div>
                  <div className="col-sm-6">
                    <div className="p-number">

                      <Controller
                        name="vehicleCode"
                        rules={{ required: true }}
                        control={control}
                        render={({ field }) => <TextField
                          {...field}
                          style={{ width: "100%" }}
                          label=""
                          variant="outlined"
                          size="small"
                          error={errors.vehicleCode ? true : false}
                          helperText={""}
                        />}
                      />
                    </div>
                    <span className="p-num-span mr-2">
                      vehicle Code
                    </span>
                    {errors.vehicleCode && <p className="text-danger2">should not be blank</p>}

                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-sm-6">
                    <div className="p-number">
                      <Controller
                        name="fleetName"
                        control={control}
                        render={({ field }) => <TextField
                          {...field}
                          style={{ width: "100%" }}
                          label=""
                          variant="outlined"
                          size="small"
                          helperText={""}
                        />}
                      />


                    </div>
                    <span className="p-num-span mr-2">
                      Fleet Name
                    </span>

                  </div>
                  <div className="col-sm-6">
                    <div className="p-number">

                      <Controller
                        name="SensorSerialNumber"
                        rules={{ required: true }}
                        control={control}
                        render={({ field }) => <TextField
                          {...field}
                          style={{ width: "100%" }}
                          label=""
                          variant="outlined"
                          disabled={item ? true : false}
                          size="small"
                          error={errors.SensorSerialNumber ? true : false}
                          helperText={""}
                        />}
                      />
                    </div>
                    <span className="p-num-span mr-2">
                      Sensor Serial Number
                      {errors.SensorSerialNumber && <p className="text-danger2">should not be blank</p>}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form >
    </>
  );
};

export default memo(AssetDetail);